import { Provider } from 'react-redux';

import { action } from '@storybook/addon-actions';
import { Meta, StoryObj } from '@storybook/react';

import { store } from 'store';

import { WalkThrough } from './WalkThrough';

const meta: Meta<typeof WalkThrough> = {
  title: 'features/WalkThrough',
  component: WalkThrough,
  args: {
    handleClose: action('exit'),
  },
};

export default meta;

type Story = StoryObj<typeof WalkThrough>;

export const Basic: Story = {
  render: args => (
    <Provider store={store}>
      <WalkThrough {...args} />
    </Provider>
  ),
};
